module.exports = __webpack_public_path__ + "static/media/projects_image.b8ba9487.svg";